import { useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { FileSignature, Printer } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;
const imgUrl = (t) => `${API}/api/auth/disclaimer-signature/${t}.png`;
const esc = (s) => String(s || "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

const printRecord = (u, s) => {
  const w = window.open("", "_blank");
  w.document.write(`<html><head><title>Signed disclaimer - ${esc(u.email)}</title></head><body style="font-family:Arial;padding:32px;max-width:760px">
    <h2>Elite Leads MLO Disclaimer — signed record</h2>
    <p><b>MLO:</b> ${esc(`${u.first_name || ""} ${u.last_name || ""}`)} (${esc(u.email)}) · NMLS #${esc(u.nmls_number || "-")}</p>
    <p><b>Typed name:</b> ${esc(s.signed_name)}<br><b>Signed at (UTC):</b> ${esc(s.signed_at)}<br><b>IP address:</b> ${esc(s.ip)}<br><b>Device:</b> ${esc(s.user_agent)}<br><b>Version:</b> ${esc(s.version)}</p>
    <ol>${(s.terms || []).map((t) => `<li style="margin-bottom:6px">${esc(t)}</li>`).join("")}</ol>
    <p><b>Signature:</b><br><img src="${imgUrl(s.token)}" style="max-width:420px;border:1px solid #ccc"></p>
    <script>document.querySelector("img").onload=()=>window.print()</script></body></html>`);
  w.document.close();
};

export const DisclaimerArchiveButton = ({ u }) => {
  const [open, setOpen] = useState(false);
  const [d, setD] = useState(null);
  const show = () => { setOpen(true); api.get(`/admin/users/${u.id}/disclaimers`).then((r) => setD(r.data)); };
  return (
    <>
      <Button size="sm" variant="ghost" onClick={show} data-testid={`disclaimer-archive-${u.id}`}><FileSignature className="mr-1 h-3.5 w-3.5" /> Disclaimer</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-h-[90vh] max-w-2xl overflow-y-auto" data-testid="disclaimer-archive-dialog">
          <DialogHeader>
            <DialogTitle>Signed disclaimers — {u.first_name} {u.last_name}</DialogTitle>
            <DialogDescription>Every disclaimer this MLO signed, newest first. Print or save as PDF for a chargeback dispute.</DialogDescription>
          </DialogHeader>
          {!d && <p className="text-sm text-slate-400">Loading…</p>}
          {d && d.signatures.length === 0 && (
            <p className="text-sm text-slate-500" data-testid="disclaimer-archive-empty">
              No drawn signature on file yet{d.legacy_typed ? ` — typed-name only: "${d.legacy_typed.signed_name}" on ${new Date(d.legacy_typed.signed_at).toLocaleString()} (v${d.legacy_typed.version})` : ""}. They'll sign with a drawn signature at their next login.
            </p>
          )}
          {d?.signatures.map((s) => (
            <div key={s.id} className="rounded-lg border border-slate-200 p-4" data-testid={`disclaimer-record-${s.id}`}>
              <div className="flex flex-wrap items-start justify-between gap-2">
                <div className="text-sm">
                  <div className="font-semibold text-slate-900">{s.signed_name} · v{s.version}</div>
                  <div className="text-xs text-slate-500">{new Date(s.signed_at).toLocaleString()} · IP {s.ip || "—"}</div>
                  <div className="max-w-md truncate text-xs text-slate-400" title={s.user_agent}>{s.user_agent}</div>
                </div>
                <Button size="sm" variant="outline" onClick={() => printRecord(u, s)} data-testid={`disclaimer-print-${s.id}`}><Printer className="mr-1 h-3.5 w-3.5" /> Print / PDF</Button>
              </div>
              <img src={imgUrl(s.token)} alt="Signature" className="mt-3 max-h-28 rounded border border-slate-200 bg-white" data-testid={`disclaimer-sig-img-${s.id}`} />
              {s.terms?.length > 0 && (
                <details className="mt-2 text-xs text-slate-600"><summary className="cursor-pointer font-semibold">Terms signed ({s.terms.length})</summary>
                  <ol className="mt-1 list-decimal space-y-1 pl-4">{s.terms.map((t) => <li key={t}>{t}</li>)}</ol></details>
              )}
            </div>
          ))}
        </DialogContent>
      </Dialog>
    </>
  );
};
